// extracted by mini-css-extract-plugin
export var createdDate = "_ju-1";
export var divider = "_ju-2";
export var headerDivider = "_ju-3";
export var messagesCard = "_ju-0";
export var messagesContainer = "_ju-7";
export var messagesContainerWrapper = "_ju-4";
export var pointerCapturingButtonBoxes = "_ju-a";
export var showLeftPanelButton = "_ju-9";
export var showMoreButton = "_ju-c";
export var showMoreButtonContainer = "_ju-b";
export var summaryTitle = "_ju-6";
export var systemMessageCardWrapper = "_ju-d";
export var topButtons = "_ju-8";
export var withPadding = "_ju-5";